import { useState } from "react";

const usePayments = () => {

    const tabs = [
        { label: "PAYOUTS", value: "PAYOUTS" },
        { label: "COLLECTIONS", value: "COLLECTIONS" },
        { label: 'BENEFICIARIES', value: 'BENEFICIARIES' }
    ];

    const [selectedTab, setSelectedTab] = useState('PAYOUTS');

    return {
        tabs,
        selectedTab,
        setSelectedTab,
    };
}

export default usePayments;